export default __webpack_public_path__ + "static/B0128-769d524261d1a60e72dd8de59f2e9869.png";